// extracted by mini-css-extract-plugin
export default {"principal":"Upi40SqfvqMPJA606Z1_"};